/** @format */

import { formatFloorNumber } from "../../../utils/decimal";

export const salesReportConfirmationColumns = [
  {
    key: "productTypeName",
    label: "",
    align: "left",
    isGroup: true,
    dataKey: "index",
    cellProps: {
      width: 5,
      rowCell: {
        borderRight: "1px solid #e0e0e0",
      },
    },
  },
  {
    key: "title",
    label: "",
    align: "left",
    cellProps: {
      minWidth: 20,
      width: "16.5%",
    },
  },
  {
    key: "feature",
    label: "地物",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16.5%",
    },
    render: item => {
      return item.title === "手数料率"
        ? formatFloorNumber(item?.feature, 1)
        : new Intl.NumberFormat().format(item?.feature.toFixed(0));
    },
  },
  {
    key: "federation",
    label: "県内経済連",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16.5%",
    },
    render: item => {
      return item.title === "手数料率"
        ? formatFloorNumber(item?.federation, 1)
        : new Intl.NumberFormat().format(item?.federation.toFixed(0));
    },
  },
  {
    key: "travel",
    label: "旅物",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16.5%",
    },
    render: item => {
      return item.title === "手数料率"
        ? formatFloorNumber(item?.travel, 1)
        : new Intl.NumberFormat().format(item?.travel.toFixed(0));
    },
  },
  {
    key: "outside",
    label: "県外",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16.5%",
    },
    render: item => {
      return item.title === "手数料率"
        ? formatFloorNumber(item?.outside, 1)
        : new Intl.NumberFormat().format(item?.outside.toFixed(0));
    },
  },
  {
    key: "total",
    label: "合計",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16.5%",
    },
    render: item => {
      return item.title === "手数料率"
        ? formatFloorNumber(item?.total, 1)
        : new Intl.NumberFormat().format(item?.total.toFixed(0));
    },
  },
];
